import { IMAGE_TYPE_LEGACY, IMAGE_TYPE } from './types';
import { sizeClassName, alignmentClassName } from './classNameStrategies';
import imageComponentWrapper from './components/ImageComponentWrapper/image-component-wrapper';
import BadPlugin from '../../components/BadPlugin';
const imageRenderDescriptor = (externalImageComponent)=>({
        component: externalImageComponent ? imageComponentWrapper(externalImageComponent) : BadPlugin,
        classNameStrategies: {
            size: sizeClassName,
            alignment: alignmentClassName
        }
    });
export function typeMapper(externalImageComponent) {
    return ()=>({
            [IMAGE_TYPE_LEGACY]: imageRenderDescriptor(externalImageComponent),
            [IMAGE_TYPE]: imageRenderDescriptor(externalImageComponent)
        });
}
